// 타로 탁자 모드(9/28 사장님 「카드는 너가 지금 보여준것처럼 탁자에 두는게 맞는것같고 카드 선택만 방법 생각하면 될 것 같아」 → 「1번 해봐 그리고 한번 내가 테스트 해볼게」).
// 카드를 영상 속 탁자 윗면에 눕힌다 — 같은 원근 · 천 위 그림자 · 탁자와 같은 빛(가운데 밝고 양옆 · 안쪽 어둡게).
//  · 탁자 윗면은 원본 영상 위에서 77.5% ~ 94.3%(대기 영상 한 장면에서 잰 것). 카메라는 살짝 내려다봄(10°)으로 어림하고, 원근 거리는 영상 높이의 0.95.
//  · 짧은 화면(영상 아래가 잘려 탁자가 안 보이던 폰)은 영상 전체가 보이게 높이에 맞춘다.
//  · 긴 화면(PC · 세로로 긴 창 · 툴바 없는 폰)도 영상이 화면 높이를 채운다(양옆은 가운데 기준으로 조금 더 잘림).
//    9/30 사장님 「탁자 아래로 공간이 생기는데 왜이런거야?」 — 예전 배치(영상은 높이의 88% · 폭의 1.2배까지, 아래 12%는 부채꼴을 깔던 빈 탁자 띠)를 탁자 모드에도 쓰고 있었다.
//    탁자 모드는 카드를 영상 속 탁자에 눕히므로 그 띠가 빈 곳으로 보였다.
//  · 창 크기가 바뀌면(창 늘리기 · 다른 모니터로 옮기기 · 폰 툴바) 이미 놓인 카드도 새 크기로 다시 놓는다(relayout).
//    9/30 같은 날 「카드 위치 이상하고」 — 영상 칸만 새 크기로 바뀌고 카드는 옛 크기 자리에 남아 탁자 뒤 가장자리에 걸려 보였다.
// 고르기(사장님이 고른 1번): 탁자 근처에 손가락을 대면 가장 가까운 카드가 탁자에서 들리고(양옆 카드는 조금 벌어짐), 댄 채 옆으로 움직이면 들리는 카드가 따라 바뀌고,
//   떼면 그 카드를 뽑는다(톡 누르면 가장 가까운 카드). 마우스는 올리면 들리고 누르면 뽑는다. 부채꼴은 얕은 호라 손가락을 옆으로 옮기는 만큼 카드가 고르게 바뀐다.
// 9/28 사장님(탁자 모드 시험 뒤) 「선택한 카드가 위에 떠 있는게 나을것같은데? 캐릭터 허리 높이쯤으로 올라오고 첫번째 선택카드부터 왼쪽에서 오른쪽으로 정렬 한장이면 바로 보여주고」
//   · 「공중에 떠 있을때 카드 뒷면이 온전히 보이게끔」 — 뽑은 카드는 탁자에서 떠올라 마녀 허리 높이(영상 높이의 63% — 허리는 약 67%, 탁자 가장자리 77.5%)의 공중에
//   보는 쪽을 향해 똑바로 선다(기울지 않아 뒷면이 온전히 보인다). 첫 장부터 왼쪽에서 오른쪽으로. 다 뽑으면 나머지는 옆으로 쓸고, 뒤집기 · 앞면도 공중 그 자리에서.
//   한 장(오늘의 카드)은 뽑으면 누르지 않아도 바로 뒤집는다(tarot.js run — 「한번 뒤집어 보세요」 대사도 뺀다).
// 켜고 끄기: app/data/tarot.json 「탁자」 켜기(true · "시험" · false) — 주소 ?탁자=1 · ?탁자=0 이 이긴다(tarot.js setTable). 꺼져 있으면 tarot.js 의 예전 배치 그대로.
// tarot.js 의 전역(stage · plane · G · deck · fan · slots · N · mk · snd · SFX · front · idle · AUTO · labels …)을 쓴다. 이 파일을 먼저 싣고, 부르는 것은 흐름이 돈 뒤다.
const TB = (() => {
  const TH = 80 * Math.PI / 180, SIN = Math.sin(TH), COS = Math.cos(TH), R2D = 180 / Math.PI;
  const TOP = .775, NEAR = .943;                  // 원본 영상에서 탁자 윗면 뒤 · 앞 가장자리(위에서부터)
  let g = null, R = 0, S0 = 0, A = 0;
  const f = (n) => Math.round(n * 100) / 100;
  const k = (s) => g.P / (g.P + s * SIN);          // 탁자 깊이 s 에서 화면 크기 비율(앞 가장자리 = 1)

  // 영상 칸 · 탁자 면. 영상은 늘 화면 높이를 채운다 — 긴 화면이면 폭을 채우고 양옆이 조금 잘림
  function geo() {
    const W = stage.clientWidth, H = stage.clientHeight, vh = Math.max(H, W * 16 / 9), oy = H - vh;
    const box = { x: 0, w: W, h: H };
    const old = g;
    const P = vh * .95, cx = W / 2, cy = oy + vh / 2, yN = oy + vh * NEAR, yF = oy + vh * TOP;
    const sF = P * (yN - yF) / (P * COS + (yF - cy) * SIN);   // 탁자 깊이(앞 가장자리 크기 기준) — 뒤 가장자리가 화면 yF 에 오는 깊이
    g = { W, H, vh, oy, box, P, cx, cy, yN, yF, sF, half: W / 2, cw: vh * .082 };
    stage.style.setProperty("--sh", box.h + "px"); stage.style.setProperty("--sx", box.x + "px"); stage.style.setProperty("--sw", box.w + "px");
    const fp = floatAt(0); stage.style.setProperty("--subb", Math.round(H - (fp.Y - fp.cw * 1.72 / 2) + 10) + "px");   // 자막은 공중 카드 줄 바로 위
    plane.style.perspective = P + "px"; plane.style.perspectiveOrigin = `${f(cx)}px ${f(cy)}px`;
    G = { W, H, SH: box.h, cw: g.cw, top: yF, OFF: 0 };
    fanFit();
    if (old && (old.W !== W || old.H !== H)) relayout(old);
    return G;
  }
  // 창 크기가 바뀌면 탁자 위 · 공중의 카드를 새 크기로 다시 놓는다. 영상은 위 · 가운데 기준으로 커지고 작아지므로
  // 탁자 면 위 자리(가로는 가운데에서 떨어진 만큼 · 깊이 · 뜬 높이 · 크기)를 영상 높이 비율로 늘리면 같은 자리에 온다. 옮기는 동안은 움직임을 끈다.
  function relayout(old) {
    plane.querySelectorAll(".card").forEach((c) => {
      const p = c._pl; if (!p) return;
      const was = c.style.transition; c.style.transition = "none";
      if (p.float) floatPut(c, p.float.j, { up: p.float.up });
      else { const r = g.vh / p.vh, o = { ...p.o, lift: (p.o.lift || 0) * r }; if (p.o.cw) o.cw = p.o.cw * r; put(c, g.cx + (p.x - p.cx) * g.half / old.half, p.s * r, o); }
      void c.offsetWidth; c.style.transition = was;
    });
    if (plane.querySelector(".plab") && typeof labels === "function") labels();
  }
  // 탁자 면 위 점(x 가로 · s 앞 가장자리에서 안쪽 · z 면에서 뜬 높이, 모두 앞 가장자리 크기 기준) → 화면 점
  function proj(x, s, z = 0) { const y3 = g.yN - s * COS - z * SIN, z3 = -s * SIN + z * COS, q = g.P / (g.P - z3); return { x: g.cx + (x - g.cx) * q, y: g.cy + (y3 - g.cy) * q }; }

  // 카드 한 장의 transform — 탁자 면(앞 가장자리 줄을 축으로 80° 눕힘) 위 (x, s) 에 두고, 면 위에서 돌리고(rz) · 띄우고(lift) · 보는 쪽으로 세우고(stand) · 뒤집는다(up).
  // 카드 상자는 처음 폭(bw)으로 두고 scale 로 크기를 바꾼다. 함수 차례를 늘 같게 두어 옮길 때 부드럽게 이어진다.
  function tf(c, x, s, o = {}) {
    const bw = +c.dataset.bw, ch = bw * 1.72, q = (o.cw || g.cw) / bw;
    return `translate3d(0px,${f(g.yN)}px,0px) rotateX(80deg) translate3d(${f(x)}px,${f(-s)}px,${f(o.lift || 0)}px) rotateZ(${f(o.rz || 0)}deg) rotateX(${f(-(o.stand || 0))}deg) scale(${q.toFixed(4)}) rotateY(${o.up ? 180 : 0}deg) translate3d(${f(-bw / 2)}px,${f(-ch / 2)}px,0px)`;
  }
  function put(c, x, s, o = {}) {
    if (!c.dataset.bw) { c.dataset.bw = g.cw; c.style.setProperty("--cw", g.cw + "px"); }
    c.dataset.x = x; c.dataset.s = s; c._pl = { x, s, o, cx: g.cx, vh: g.vh };   // 다시 놓을 때 쓴다(relayout)
    c.style.transform = tf(c, x, s, o);
    // 그림자 — 앞(보는 쪽)에서 오는 빛에 탁자 안쪽으로 드리운다. 카드 안 좌표로 돌려 둔다(앞면이 위면 좌우가 바뀐다). 뜬 카드는 옅고 넓게.
    const q = (o.cw || g.cw) / +c.dataset.bw, lifted = (o.lift || 0) > 4, r = (o.rz || 0) / R2D, d = (lifted ? 6 : 2.6) / q;
    const ox = -Math.sin(r) * d * (o.up ? -1 : 1), oy = -Math.cos(r) * d;
    c.style.boxShadow = o.float ? `0 ${f(6 / q)}px ${f(16 / q)}px rgba(0,0,0,.55)`   // 공중에 서서 보는 쪽을 향한 카드 — 화면 아래로 떨어지는 그림자
      : lifted ? `${f(ox)}px ${f(oy)}px ${f(12 / q)}px rgba(0,0,0,.4)`
      : `0 0 ${f(1.4 / q)}px ${f(.5 / q)}px rgba(0,0,0,.75),${f(ox)}px ${f(oy)}px ${f(5 / q)}px rgba(0,0,0,.5)`;
    if (o.float) { c.style.setProperty("--dim", ".02"); return; }
    // 빛 — 탁자 양끝으로 갈수록 아주 조금 어둡게(카드 위에 옅은 어둠 — CSS 필터 없이).
    // 9/29 사장님 「카드가 너무 어두워서 안보여 시인성이 너무 안좋아」 — 예전(가운데 10% ~ 가장자리 · 안쪽 54%)에서 2 ~ 8% 로 줄였다.
    const dx = Math.min(1, Math.abs(proj(x, s).x - g.cx) / g.half);
    c.style.setProperty("--dim", f(.02 + .06 * dx * dx));
  }

  // 공중 자리(뽑은 카드) — 화면 (X, Y) 가운데 · 폭 cw. 첫 장이 왼쪽
  const FLOAT_Y = .63;
  function floatAt(j) {
    const vw = g.half * 2, cw = vw * (N === 5 ? .14 : N === 1 ? .26 : .2), gap = cw * (N === 5 ? 1.2 : 1.28);
    return { X: g.cx + (j - (N - 1) / 2) * gap, Y: Math.max(cw * .86 + 16, g.oy + g.vh * FLOAT_Y), cw };
  }
  // 화면 (X, Y) 에 보는 쪽을 향해 똑바로 선 카드 — 탁자 면과 같은 함수 차례(떠오를 때 부드럽게 이어진다). 원근이 걸리지 않는 깊이(z=0)에 둔다:
  // 면 위 s = d·cos80°, 면에서 뜬 높이 = d·sin80°(d = 탁자 앞 가장자리 줄에서 Y 까지), 세움 80°(탁자 기울기를 되돌림).
  function floatPut(c, j, o = {}) { const p = floatAt(j), d = g.yN - p.Y; put(c, p.X, d * COS, { lift: d * SIN, stand: 80, cw: p.cw, up: o.up, float: true }); c._pl = { float: { j, up: o.up } }; }
  const floatBottom = () => { const p = floatAt(0); return p.Y + p.cw * 1.72 / 2; };

  // 더미
  const deckS = () => g.sF * .42;
  function deal() {
    geo(); const s0 = deckS();
    deck = [...Array(14)].map((_, i) => { const c = mk(i + 1); put(c, g.cx, s0, { lift: g.vh * .12 }); c.style.opacity = 0; return c; });
    void plane.offsetWidth; settle(true); snd("deck", { delay: 0.3, level: 0.7 });
  }
  function settle(show) { const s0 = deckS(); deck.forEach((c, i) => { if (show) c.style.opacity = 1; put(c, g.cx + (i % 3 - 1) * .4, s0, { lift: i * .6, rz: i % 2 ? .6 : -.6 }); }); }
  // 섞기 — 카드마다 탁자 위에서 쉬는 자리를 떠나 한 바퀴 도는 고리(tarot.js swirl 과 같은 결, 탁자 면 위에서)
  function swirl(c, i) {
    const x0 = +c.dataset.x, s0 = +c.dataset.s, rz0 = i % 2 ? .6 : -.6, lift0 = i * .6, dir = Math.random() < .5 ? 1 : -1, ph = Math.random() * Math.PI * 2;
    const rx = g.half * (.12 + Math.random() * .2) / k(s0), rs = rx * (.35 + Math.random() * .25), tw = 4 + Math.random() * 8, up = 4 + Math.random() * 10, K = 18, frames = [];
    for (let j = 0; j <= K; j++) {
      const a = ph + dir * (j / K) * Math.PI * 2;
      frames.push({ transform: tf(c, x0 + rx * (Math.cos(a) - Math.cos(ph)), s0 + rs * (Math.sin(a) - Math.sin(ph)), { rz: rz0 + tw * Math.sin(a - ph), lift: lift0 + up * Math.sin((j / K) * Math.PI) }) });
    }
    return c.animate(frames, { duration: 1300 + Math.random() * 900, iterations: Infinity, easing: "linear" });
  }
  // 떼기 — 세 더미. 더미가 작아 탁자 어디를 눌러도 가장 가까운 더미를 고른다(단추는 빼고)
  function cut() {
    return new Promise((res) => {
      geo(); const s0 = deckS(), xs = [-1, 0, 1].map((j) => g.cx + j * g.half * .56 / k(s0)), piles = [deck.slice(0, 5), deck.slice(5, 10), deck.slice(10)];
      piles.forEach((p, j) => p.forEach((c, i) => { put(c, xs[j], s0, { lift: i * .6, rz: (j - 1) * 4 }); c.classList.add("pick"); c.onclick = () => choose(j); }));
      snd("cutSplit", { level: 0.8 });
      let done = false;
      const tap = (e) => {
        if (e.target.closest?.("button")) return;
        const X = e.clientX - stage.getBoundingClientRect().left; let b = 1, bd = 1e9;
        piles.forEach((p, j) => { const d = Math.abs(proj(+p[0].dataset.x, +p[0].dataset.s).x - X); if (d < bd) { bd = d; b = j; } }); choose(b);
      };
      stage.addEventListener("pointerup", tap);
      function choose(j) {
        if (done) return; done = true; stage.removeEventListener("pointerup", tap); deck.forEach((c) => { c.classList.remove("pick"); c.onclick = null; });
        const order = [...piles.filter((_, m) => m !== j).flat(), ...piles[j]]; order.forEach((c, i) => { c.style.zIndex = i + 1; }); deck = order;
        snd("cutStack", { delay: 0.4, level: 0.8 }); setTimeout(() => { settle(); setTimeout(res, 700); }, 80);
      }
      if (AUTO) setTimeout(() => choose(1), 1000);
    });
  }

  // 펼치기 — 스물두 장을 얕은 호로(호의 가운데는 탁자 앞쪽 밖). 호가 탁자 윗면 안(보이는 폭 · 뒤 가장자리)에 들어오게 양끝 각(A)을 맞춘다.
  function fanFit() {
    const cw = g.cw, ch = cw * 1.72; R = g.sF * 1.9; S0 = g.sF * .7 - R; A = 32;
    for (let i = 0; i < 60 && A > 8; i++) {
      const a = A / R2D, s = S0 + R * Math.cos(a), ext = R * Math.sin(a) + cw / 2 * Math.cos(a) + ch / 2 * Math.sin(a);
      if (ext * k(s) <= g.half * .92) break; A -= .5;
    }
  }
  function fanAt(i, n, da = 0) { const a = (-A + 2 * A * i / (n - 1) + da) / R2D; return { x: g.cx + R * Math.sin(a), s: S0 + R * Math.cos(a), rz: a * R2D, a }; }
  function spread() {
    geo(); const s0 = deckS(); deck.forEach((c) => c.remove()); deck = [];
    fan = [...Array(22)].map((_, i) => { const c = mk(20 + i); put(c, g.cx, s0, { lift: 2 }); return c; });
    void plane.offsetWidth; snd("fan", { delay: 0.03, level: 0.9 });
    return new Promise((res) => { fan.forEach((c, i) => setTimeout(() => { const p = fanAt(i, 22); put(c, p.x, p.s, { rz: p.rz }); }, 30 + i * 38)); setTimeout(res, 22 * 38 + 760); });
  }

  // 고르기(1번) — 들린 카드 · 벌어지는 이웃 · 떼면 뽑기. 톡 누르기 · 마우스도 같은 길
  function pickN() {
    return new Promise((res) => {
      geo();
      const taken = new Set(), step = 2 * A / 21;
      let hot = -1, pid = null, lastSnd = 0;
      const lay = () => fan.forEach((c, i) => {
        if (taken.has(i)) return;
        let da = 0;
        if (hot >= 0 && i !== hot) { const dd = i - hot, ad = Math.abs(dd); if (ad <= 3) da = Math.sign(dd) * step * [0, .55, .3, .12][ad]; }
        const want = i === hot ? "h" : da ? "d" + f(da) : "";
        if ((c.dataset.st || "") === want) return; c.dataset.st = want;
        const p = fanAt(i, 22, da);
        if (i === hot) { const cw = g.cw * 1.22, st = 38; put(c, p.x, p.s, { rz: p.rz, cw, stand: st, lift: cw * 1.72 / 2 * Math.sin(st / R2D) + g.cw * .25 }); c.style.zIndex = 70; }
        else { put(c, p.x, p.s, { rz: p.rz }); c.style.zIndex = 20 + i; }
      });
      // 손가락 가로 자리에서 가장 가까운 카드(뽑은 카드는 빼고) — 얕은 호라 카드 사이 간격이 고르다
      const near = (X) => { let b = -1, bd = 1e9; fan.forEach((c, i) => { if (taken.has(i)) return; const p = fanAt(i, 22), d = Math.abs(proj(p.x, p.s).x - X); if (d < bd) { bd = d; b = i; } }); return b; };
      const setHot = (i) => {
        if (i === hot) return; hot = i; lay();
        const t = performance.now(); if (i >= 0 && t - lastSnd > 70) { lastSnd = t; snd("lift", { level: 0.16 }); }
      };
      const pos = (e) => { const r = stage.getBoundingClientRect(); return { X: e.clientX - r.left, Y: e.clientY - r.top }; };
      const zone = (e) => !e.target.closest?.("button") && pos(e).Y > Math.max(g.yF - g.vh * .12, floatBottom() + 4);   // 공중 카드 줄 아래만
      const down = (e) => { if (pid != null || !zone(e)) return; pid = e.pointerId; try { stage.setPointerCapture(pid); } catch { /* 그대로 */ } setHot(near(pos(e).X)); };
      const move = (e) => { if (pid != null) { if (e.pointerId === pid) setHot(near(pos(e).X)); } else if (e.pointerType === "mouse") setHot(zone(e) ? near(pos(e).X) : -1); };
      const up = (e) => { if (pid == null || e.pointerId !== pid) return; pid = null; const i = hot; hot = -1; if (i >= 0) take(i); else lay(); };
      const cancel = (e) => { if (pid != null && e.pointerId === pid) { pid = null; setHot(-1); } };
      const out = (e) => { if (pid == null && e.pointerType === "mouse") setHot(-1); };
      const ev = [["pointerdown", down], ["pointermove", move], ["pointerup", up], ["pointercancel", cancel], ["pointerleave", out]];
      fan.forEach((c, i) => { c.style.transition = "transform .24s cubic-bezier(.2,.7,.2,1),opacity .5s"; c.dataset.keyboardPick = "1"; c.onclick = () => take(i); });
      stage.classList.add("picking"); ev.forEach(([n, h]) => stage.addEventListener(n, h));
      function take(i) {
        if (taken.has(i) || slots.length >= N) return;
        const c = fan[i], ord = slots.length; taken.add(i); slots.push(c); c.dataset.st = "t"; delete c.dataset.keyboardPick; c.onclick = null;
        c.style.transition = "transform .8s cubic-bezier(.2,.7,.2,1),opacity .5s"; c.style.zIndex = 80 + ord; floatPut(c, ord); snd("pick", { level: 0.75 });
        if (hot === i) hot = -1; lay();
        if (slots.length === N) {
          fan.forEach(c => { delete c.dataset.keyboardPick; c.onclick = null; });
          ev.forEach(([n, h]) => stage.removeEventListener(n, h)); stage.classList.remove("picking"); hot = -1; lay();
          setTimeout(() => { fan.forEach((x) => { x.style.transition = ""; }); res(slots.map((s) => fan.indexOf(s))); }, 600);
        }
      }
      if (AUTO) [3, 10, 17, 6, 13].slice(0, N).forEach((i, n) => setTimeout(() => take(i), 900 + n * 600));
    });
  }

  // 모으기 — 나머지는 탁자 오른쪽 밖으로 쓸고, 뽑은 카드는 공중 그 자리에
  function gather() {
    geo(); const s0 = g.sF * .5, sx = g.cx + g.half * 1.5 / k(s0);
    fan.filter((c) => !slots.includes(c)).forEach((c) => { put(c, sx, s0, { rz: 80 }); c.style.opacity = 0; setTimeout(() => c.remove(), 900); });
    slots.forEach((c, j) => { floatPut(c, j); c.style.zIndex = 90 + j; });
    // 자리 이름 칸 폭 = 화면에서 카드 사이 간격(이름이 길면 두 줄로 — 옆 이름과 붙지 않게)
    const gap = N > 1 ? floatAt(1).X - floatAt(0).X : g.half;
    stage.style.setProperty("--labw", Math.round(Math.max(40, Math.min(150, gap - 6))) + "px");
    snd("sweep", { level: 0.45 });
    setTimeout(() => { labels(); SFX?.chime?.(); }, 1300);
  }
  // 뒤집을 때 큰 카드(#big)가 탁자 위 카드 자리에서 떠오르게 — 화면에 보이는 카드 네모(폭 · 높이)로 기울기를 맞춘다(tarot.js onSlot 과 같은 꼴)
  function onSlot(j, face) {
    const r = slots[j].getBoundingClientRect(), st = stage.getBoundingClientRect(), b = getComputedStyle($("big"));
    const bw = parseFloat(b.width), bh = parseFloat(b.height), bl = parseFloat(b.left), bt = parseFloat(b.top);
    const s = r.width / bw, a = Math.acos(Math.min(1, r.height / Math.max(1, r.width * 1.72))) * R2D;
    const dx = r.left - st.left + r.width / 2 - (bl + bw / 2), dy = r.top - st.top + r.height / 2 - (bt + bh / 2);
    return `translate(${f(dx)}px,${f(dy)}px) scale3d(${f(s)},${f(s)},${f(s)}) rotateX(${f(a)}deg) rotateY(${face}deg)`;
  }
  function laySlot(c, j) { floatPut(c, j, { up: true }); }
  // 뒤집을 카드는 작아서 탁자 어디를 눌러도 뒤집는다(단추는 빼고)
  function tapFlip(c) {
    const stop = () => stage.removeEventListener("pointerup", h);
    const h = (e) => { if (e.target.closest?.("button")) return; const fn = c.onclick; stop(); if (fn) fn(); };
    stage.addEventListener("pointerup", h);
  }

  // 10/8 사장님 「쓸모 없는 코드는 … 지워버려」 — 양옆 빈 곳을 영상 양끝 벽으로 이어 그리던 것(paintSide · 그 정지 그림 받기)을 지웠다.
  //   9/30 부터 영상이 늘 화면 폭을 채워(위 geo 의 box.x 0) 그릴 빈 곳이 없었고 그 판(.side)도 숨겨 둔 채였는데, 옛 마녀 그림(front.jpg)을 받기만 했다
  function enable() {
    stage.classList.add("table");
  }
  return { enable, geo, proj, deal, settle, swirl, cut, spread, pickN, gather, onSlot, laySlot, tapFlip, fanAt, floatAt, get g() { return g; } };
})();
